<template>
   
    <div> 
        <div class="crumbs" hidden="true"  style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 权益权益
                </el-breadcrumb-item>
                <el-breadcrumb-item>权益管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
          <el-card shadow="hover"  class="searchCard" > 
                <span class="label-span">
                    <label class="label">权益名称</label> 
                    <el-input v-model.trim="query.name" placeholder="权益名称" class="handle-input mr15"></el-input> 
                </span>
                <span class="label-span">
                    <label class="label">权益状态</label> 
                    <el-select v-model="query.status"  placeholder="权益状态" clearable class="handle-select mr10">
                        <el-option value="" label="全部"  />  
                        <el-option value="1" label="开启"  /> 
                        <el-option value="0" label="禁用"  /> 
                    </el-select>
                </span>
                <el-button type="success" icon="el-icon-search"  class="mr10"  @click="handleSearch">搜索</el-button>
                <el-button type="error" icon="el-icon-refresh" class="mr10"  @click="refreshSearch">重置</el-button>
                <el-button  type="primary"  icon="el-icon-lx-roundadd" class="mr10"  @click="addBind" >新增权益</el-button> 
               
               
          </el-card>
          <el-card shadow="hover"  class="containCard" >
            <el-table :data="tableData" border class="table"  ref="multipleTable" header-cell-class-name="table-header"  @selection-change="handleSelectionChange"  >
                <!--<el-table-column type="selection" width="35" align="center"></el-table-column>-->
                <el-table-column prop="id" width="70" align="center" label="权益ID"></el-table-column>
                <el-table-column prop="name" min-width="160" align="left" label="权益名称"> </el-table-column>
                <el-table-column prop="fag" min-width="120" align="left" label="权益标识"> </el-table-column>
                <el-table-column prop="status" min-width="80" align="center" label="权益状态">
                      <template slot-scope="scope" >   
                        <el-tooltip :content="scope.row.status=='1'?'权益已开启':'权益已关闭'" placement="top">
                            <el-switch @change="handleStatus(scope.$index, scope.row)"
                                v-model="scope.row.status"
                                active-color=""
                                inactive-color=""
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-tooltip>
                    </template> 
                </el-table-column>

                <el-table-column prop="createTime" min-width="165" align="center"  label="推送地址"> </el-table-column>  
                <el-table-column prop="createTime" min-width="165" align="center"  label="创建时间"> </el-table-column>  
                <el-table-column label="操作" min-width="180" align="center"  fixed="right">
                    <template slot-scope="scope"> 
                        <span class='tableOperBtn' @click="handleEdit(scope.$index, scope.row)" ><i class='el-icon-edit'></i> 编辑</span>
                        <span class='tableOperBtn' @click="handDelete(scope.$index, scope.row)" ><i class='el-icon-delete'></i> 删除</span>
                    </template>
                </el-table-column>
                  
            </el-table>
            <div class="pagination">
                <el-pagination 
                   background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10, 20, 50]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange" 
                ></el-pagination>
            </div>
        </el-card> 
        <!-- 新建自主权益弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="新增权益" :visible.sync="addVisible" :modal-append-to-body='false' top="100px" width="580px">
            <el-form ref="form1" :model="form1" label-width="80px" @submit.native.prevent="saveForm">
                <el-form-item label="权益名称" required style="width:50%;display:inline-block;margin-top:-25px;">
                    <el-input v-model.trim="form1.name"  placeholder="权益名称" style="width:100%" ></el-input>
                </el-form-item>
                <el-form-item label="权益标识" required style="width:50%;margin-top:-10px;display:inline-block">
                    <el-input v-model.trim="form1.fag"  style="width:100%" ></el-input>
                </el-form-item>
                <el-form-item label="额外参数1" style="width:50%;margin-top:-10px;display:inline-block">
                    <el-input v-model.trim="form1.fb1"  style="width:100%" ></el-input>
                </el-form-item>
                <el-form-item label="额外参数2" style="width:50%;margin-top:-10px;display:inline-block">
                    <el-input v-model.trim="form1.fb2"  style="width:100%" ></el-input>
                </el-form-item>
                <el-form-item label="额外参数3" style="width:50%;margin-top:-10px;display:inline-block">
                    <el-input v-model.trim="form1.fb3"  style="width:100%" ></el-input>
                </el-form-item>
                <el-form-item label="渠道 ID" style="width:50%;margin-top:-10px;display:inline-block">
                    <el-input v-model.trim="form1.appId"   style="width:100%"></el-input>
                </el-form-item>
                <el-form-item label="对接密钥" style="width:100%;margin-top:-10px;" >
                    <el-input  v-model.trim="form1.appKey"   style="width:100%"></el-input>
                </el-form-item>
                <el-form-item required label="推送地址"  style="margin-top:-10px;">
                    <el-input  v-model.trim="form1.pushUrl"   style="width:100%"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer" >
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">{{ isSubmitting ? '提交中...' : '提 交' }}</el-button>
            </span>
        </el-dialog>
         
  

        <!-- 编辑自主权益弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="编辑权益" :visible.sync="editVisible" :modal-append-to-body='false' top="100px" width="580px">
            <el-form ref="form2" :model="form2" label-width="80px">
                <el-form-item label="权益名称" style="width:50%;display:inline-block;margin-top:-25px;">
                    <el-input v-model.trim="form2.name"  placeholder="权益名称" style="width:100%" ></el-input>
                </el-form-item>
                <el-form-item label="权益标识" style="width:50%;margin-top:-10px;display:inline-block">
                    <el-input v-model.trim="form2.fag"  style="width:100%" ></el-input>
                </el-form-item>
                <el-form-item label="额外参数1" style="width:50%;margin-top:-10px;display:inline-block">
                    <el-input v-model.trim="form2.fb1"  style="width:100%" ></el-input>
                </el-form-item>
                <el-form-item label="额外参数2" style="width:50%;margin-top:-10px;display:inline-block">
                    <el-input v-model.trim="form2.fb2"  style="width:100%" ></el-input>
                </el-form-item>
                <el-form-item label="额外参数3" style="width:50%;margin-top:-10px;display:inline-block">
                    <el-input v-model.trim="form2.fb3"  style="width:100%" ></el-input>
                </el-form-item>
                <el-form-item label="渠道 ID" style="width:50%;margin-top:-10px;display:inline-block">
                    <el-input v-model.trim="form2.appId"   style="width:100%"></el-input>
                </el-form-item>
                <el-form-item label="对接密钥" style="width:100%;margin-top:-10px;" >
                    <el-input  v-model.trim="form2.appKey"   style="width:100%"></el-input>
                </el-form-item>
                <el-form-item required label="推送地址"  style="margin-top:-10px;">
                    <el-input  v-model.trim="form2.pushUrl"   style="width:100%"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>
          
    </div>
</template>

<script>
import {fetchData,saveForm,handDelete,changeForm,changeStatus,fetchDataDir} from './qyChannel';
export default {

    data() {
        return {  
            isSubmitting: false, // 是否正在提交
            Timeout:'', 
            activeNames:1,
            select:{ option:'',  },
            sendSms:{
                code:'', 
                content:'发送验证码',
                type:'danger',
                disabled:false,
                color:'color:#fff',
             },
            
            query: { 
                pageIndex: 1,
                pageSize: 10,  
            },
            tableData: [],
            tableData2: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            editPlusVisible: false,
            addVisible: false,
            addPlusVisible:false,
            detailVisible:false, 
            dirVisible:false,
            row:{},
            pageTotal: 0,
            form: {  
                ids:'',
                names:'',
            },
            form1: {
                notifyType:'1'
            },
            form2: {   },
            form3: {   },
            form4: {   },
            idx: -1,
            id: -1
        };
    },
    created() {
         
    },
    //页面加载方法
    mounted: function () { 
        //查询列表
        this.getData();  
    },

    methods: {
        // 触发搜索按钮 
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'name', '');  
            this.$set(this.query, 'ctype');  
            this.$set(this.query, 'status');    
            this.handleSearch();
        }, 
    

        //触发刷新按钮
        refresh(){
            history.go(0);
            
        }, 

        //查询
        getData(){  
            fetchData(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal ;  
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0;
                } 
                
            });
        },
        

        // 新增权益
        addBind() {
            this.addVisible = true; 
        },
        //保存新增
        saveForm() {   
            if (this.isSubmitting) return;
            this.isSubmitting = true; // 禁用按钮
            if( !this.form1.name ){
                this.isSubmitting = false;
                this.$message.error("请填写权益名称");
                return;
            }
            if( !this.form1.fag ){
                this.isSubmitting = false;
                this.$message.error("请填写权益类型");
                return;
            } 
            this.addVisible = false;  
            this.loading = true; 
            saveForm(this.form1).then(res => {
                this.loading = false; 
                this.isSubmitting = false;
                if(res.code=='200'){  
                    this.$message.success(res.message); 
                    this.refreshSearch(); 
                }else{
                    this.addVisible = true;
                    this.$message.error(res.message); 
                } 
            });
        },

        

        // 编辑操作
        handleEdit(index, row) {
            this.editVisible = true;
            this.form2 = row; 
        },
 
        
        // 保存更改
        saveEdit() {   
            this.editVisible = false;
            changeForm(this.form2).then(res => {
                if(res.code=='200'){ 
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.editVisible = true; 
                    this.$message.error(res.message); 
                }
            });
        },
        // q启用、禁用--改变状态
        handleStatus(index, row) {  
            var tips ;
            var content;
            if(row.status=='0'){ 
                row.status='1';
                tips = "禁用";
                content = "该权益已添加商品将全部下架，确定禁用吗？";
            }else{ 
                row.status = '0';
                tips = "启用";
                content = "启用该权益前请确保渠道已对接成功？需要启用吗？"; 
            }
            // 二次确认删除
            this.$confirm(content, '提示', {
                type: 'warning'
            }).then(() => { 
                if(row.status=='0'){ 
                    row.status='1' 
                }else{ 
                    row.status='0' 
                }
                changeStatus(row).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success(tips+'成功'); 
                        this.getData();
                    }else{ 
                        if(row.status=='0'){ 
                            row.status='1' 
                        }else{ 
                            row.status='0' 
                        }
                        this.$message.error(tips+'失败');
                    } 
                });
            })
            .catch(() => {}); 
           
        },
 
        
        //详情
        handleDetail(index, row){
            this.form2 = row; 
            if(row.channelType=='1'){
                this.detailVisible = true; 
            }
            
        },
        // 删除
        handDelete(index, row) {  
            this.form.id=row.id; 
            this.form.mid = this.mid;
            this.form.stationId = this.stationId; 
            // 二次确认删除
            this.$confirm('该权益所有商品将删除，是否要删除？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(this.form).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success('删除成功'); 
                        this.$set(this.query, 'pageIndex', 1); 
                        this.getData();
                    }else if(res.code=='201'){
                        //处理该等级绑定的成员
                        this.$message.error("该权益商品仍有订单未结算，请手动结算订单！"); 
                    }else{
                        this.$message.error("删除失败"); 
                    } 
                });
            }) 
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.label{
    background: #eee;
    font-size: 14px;
    height: 32px;
    display: inline-block;
    line-height: 33px;
    width:100px;
    text-align:center;
    color: #555;
  }
  .label-span{
      display: inline-block;
      height: 45px;
  }
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 100px;
    display: inline-block;
}

.handle-input {
    width: 150px;
    display: inline-block;
}
.handle-del {
    float:right; 
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
    margin-left:0;
}
.mr15 {
    margin-right: 15px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
